import type { Messages } from '@/i18n/messages/en/index.ts'
import { agents } from './agents.ts'
import { artifacts } from './artifacts.ts'
import { auth } from './auth.ts'
import { folders } from './folders.ts'
import { groups } from './groups.ts'
import { knowledge } from './knowledge.ts'
import { marketplace } from './marketplace.ts'
import { notifications } from './notifications.ts'
import { people } from './people.ts'
import { runs } from './runs.ts'
import { sharing } from './sharing.ts'
import { systems } from './systems.ts'

/** The same keys, in Brazilian Portuguese. A missing one is a compile error, not a fallback. */
export const errors: Messages['errors'] = {
  'common.request_failed': ({ status }) => `A solicitação falhou (${status}).`,
  'common.session_expired': () => 'Sua sessão terminou. Entre novamente para continuar.',
  'common.connection_lost': () => 'A conexão com o assistente foi perdida.',
  'common.unexpected': () => 'Algo deu errado.',
  ...auth,
  ...runs,
  ...artifacts,
  ...knowledge,
  ...folders,
  ...agents,
  ...sharing,
  ...people,
  ...groups,
  ...systems,
  ...marketplace,
  // Not a refusal, and it belongs here anyway: this map is every sentence the SERVER names
  // and this client renders, and a notification is the case where that is most literally true
  // -- the key is on the row and the words are chosen when somebody opens it (D-5 amended).
  ...notifications
}
